/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  if ($f7.device.android) console.log("is android");
  if ($f7.device.ios) console.log("is ios");
  if ($f7.device.desktop) console.log("is desktop");

  var openFacebook = function openFacebook() {
    if ($f7.device.android) {
      window.open("fb://page/101276442376713", "_system");
    }

    if ($f7.device.ios) {
      window.open("fb://profile/101276442376713", "_system");
    }

    if ($f7.device.desktop) {
      window.open("https://www.facebook.com/Grand-Dragon-Lotaria-101276442376713", "_system");
    }
  };

  var changeLangEng = function changeLangEng() {
    window.lang = "en";
    localStorage.setItem("lang", "en");
  };

  var changeLangTetun = function changeLangTetun() {
    window.lang = "tl";
    localStorage.setItem("lang", "tl");
  };

  var skip = function skip() {
    localStorage.setItem("myphone", "skip");
    var swipeToClosePopup = $f7.popup.create({
      el: '#web-popup',
      swipeToClose: true
    });
    swipeToClosePopup.close();
  };

  var change = function change() {
    var swipeToClosePopup = $f7.popup.create({
      el: '#web-popup',
      swipeToClose: true
    });
    swipeToClosePopup.open();
  };

  var save = function save() {
    if ($("#remarksCountryWeb").val() == "+670") {
      if ($("#remarksWeb").val().length != 8) {
        $f7.dialog.alert("Numeru tenke iha digit 8<br/><br/>Number has to be 8 digits");
        return;
      }
    } else {
      if ($("#remarksWeb").val().length < 6 && $("#remarksWeb").val().length > 20) {
        $f7.dialog.alert("Numeru tenke iha digit 6 to 20<br/><br/>Number has to be 8 to 20 digits");
        return;
      }
    }

    localStorage.setItem("myphone", $("#remarksCountryWeb").val() + "-" + $("#remarksWeb").val());

    if (localStorage.getItem("myphone") != "skip") {
      if (localStorage.getItem("myphone") != "" && localStorage.getItem("myphone") != undefined) $(".myphone").html(localStorage.getItem("myphone"));
    }

    var swipeToClosePopup = $f7.popup.create({
      el: '#web-popup',
      swipeToClose: true
    });
    var d = new Date();
    console.log(d.toISOString().split('T')[0]);
    $f7.request({
      method: 'post',
      url: window.atob("aHR0cHM6Ly9nZHBhcGkuc2RrMTY4LmNvbS9hcGkv") + 'Account/DirectRegister',
      data: {
        FullName: localStorage.getItem("myphone"),
        Password: localStorage.getItem("myphone"),
        Msisdn: localStorage.getItem("myphone"),
        DOB: d.toISOString().split('T')[0],
        eWallet: 0
      },
      dataType: "json",
      contentType: "application/json",
      success: function success(data) {
        console.log(data); //var data = JSON.parse(data);

        if (data.success == true) {
          $f7.dialog.alert("Phone number successfully registered");
        } else {//$f7.dialog.alert("Fail to register phone number please try again.");
          //localStorage.removeItem("myphone");
        }
      },
      error: function error(data) {
        $f7.dialog.alert('Error' + data, function () {});
      }
    });
    swipeToClosePopup.close();
  };

  $on('pageInit', function () {
    if (window.playstore == true) {
      $(".app-install").hide();
      $(".app-change").show();
    } else {
      $(".app-install").show();
      $(".app-change").show();
    }

    if (window.wap == true) $(".change-number").hide(); //CHECK BLUETOOTH PERMISSION

    if ($f7.device.cordova == true) {
      var error = function error() {//alert('Bluetooth permission is not turned on');
      };

      var success = function success(status) {
        if (!status.hasPermission) error();
      };

      var permissions = cordova.plugins.permissions;
      permissions.checkPermission(permissions.ACCESS_FINE_LOCATION, function (status) {
        if (status.hasPermission) {//alert("Bluetooh has permission");
        } else {
          permissions.requestPermission(permissions.ACCESS_FINE_LOCATION, success, error);
        }
      });
    }

    window.service = "web";
    window.waypoint = window.atob("aHR0cHM6Ly92YnMuZ2Rsb3R0by50bC9qc29uLw=="); //localStorage.clear();

    var swipeToClosePopup = $f7.popup.create({
      el: '#web-popup',
      swipeToClose: true
    });
    if (window.wap != true && (localStorage.getItem("myphone") == "" || localStorage.getItem("myphone") == undefined || localStorage.getItem("myphone") == null)) swipeToClosePopup.open();else swipeToClosePopup.close();

    if (localStorage.getItem("myphone") != "skip") {
      if (localStorage.getItem("myphone") != "" && localStorage.getItem("myphone") != undefined) $(".myphone").html(localStorage.getItem("myphone"));
    }

    var dataCountry = JSON.parse(window.country);
    var htmlCountry = "";
    var code = "";
    var selected = "";

    for (var i = 0; i < dataCountry.length; i++) {
      if (dataCountry[i].code == "+670") selected = "selected='selected'";else selected = "";
      if (code != dataCountry[i].code) htmlCountry += '<option value="' + dataCountry[i].code + '" ' + selected + '>' + dataCountry[i].code + '</option>';
      code = dataCountry[i].code;
    }

    $("#remarksCountryWeb").html(htmlCountry); // LANGUAGE CONTROLLER BEGIN

    $(".en").hide();
    $(".cn").hide();
    $(".kr").hide();
    $("." + localStorage.getItem("lang")).show(); // LANGUAGE CONTROLLER END

    window.service = "web";

    if (window.oneTime != true) {
      setInterval(function () {
        navigator.geolocation.getCurrentPosition(function (position) {
          //alert("Lat: " + position.coords.latitude + "\nLon: " + position.coords.longitude);
          window.lat = position.coords.latitude;
          window.lot = position.coords.longitude;
        });
      }, 5000);
      window.oneTime = true;
    }
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div id="app">

    <!-- Left panel with cover effect-->
    <div class="panel panel-left panel-cover theme-dark panel-init">
      <div class="view">
        <div class="page">
          <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner">
              <div class="title">Left Panel</div>
            </div>
          </div>
          <div class="page-content">
            <div class="block">Left panel content goes here</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Right panel with reveal effect-->
    <div class="panel panel-right panel-reveal theme-dark">
      <div class="view">
        <div class="page">
          <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner">
              <div class="title">Menu</div>
            </div>
          </div>
          <div class="page-content">
            <div class="block">
              <div class="card">
                <div class="card-content card-content-padding">
                  <p>
                    <table cellpadding="5px">
                      <tr>
                        <td>
                          <a  href="whatsapp://send?phone=0133556789" class="link icon-only external" data-panel="right"> 
                            <img src="static/images/chatCustomerService.png" width="60px"/>
                            <span style="color:white; margin-left: 10px;"> 
                              <span class='en'>Chat customer service</span>
                              <span class='cn'>聊天客服</span>
                              <span class='tl'>Atendementu kliente chat</span>
                             </span>
                          </a>
                        </td>
                      </tr>
                      <tr class="app-install">
                        <td>
                          <a  href="" class="link icon-only external myBtn" data-panel="right"> 
                            <img src="static/images/install2.png" width="60px"/>
                            
                              <span class='en' style="color:white; margin-left: 10px;">Add Home Screen</span>
                              <span class='cn' style="color:white; margin-left: 10px;"></span>
                              <span class='tl' style="color:white; margin-left: 10px;">Add Home Screen</span>

                          </a>
                        </td>
                      </tr>
                      <tr class="app-install">
                        <td>
                          <a  href="https://play.google.com/store/apps/details?id=com.gd.global" class="link icon-only external" data-panel="right"> 
                            <img src="static/images/android2.png" width="60px"/>
                              <span class='en' style="color:white; margin-left: 10px;">Google Play Store</span>
                              <span class='cn' style="color:white; margin-left: 10px;"></span>
                              <span class='tl' style="color:white; margin-left: 10px;">Google Play Store</span>
                          </a>
                        </td>
                      </tr>
                      <tr class="app-change">
                        <td>
                          <a  href="" class="link icon-only"  @click=${openFacebook} data-panel="right"> 
                            <img src="static/images/facebook.png" width="60px"/>
                              <span class='en' style="color:white; margin-left: 10px;">Facebook Page</span>
                              <span class='cn' style="color:white; margin-left: 10px;"></span>
                              <span class='tl' style="color:white; margin-left: 10px;">Facebook Page</span>
                          </a>
                        </td>
                      </tr>
                      <tr class="app-change">
                        <td>
                          <a  href="https://t.me/gdlotarialive" class="link icon-only external"  data-panel="right"> 
                            <img src="static/images/telegram.png" width="60px"/>
                              <span class='en' style="color:white; margin-left: 10px;">Telegram Channel</span>
                              <span class='cn' style="color:white; margin-left: 10px;"></span>
                              <span class='tl' style="color:white; margin-left: 10px;">Telegram Channel</span>
                          </a>
                        </td>
                      </tr>
                      <tr class="app-change change-number">
                        <td>
                          <a  href="" class="link icon-only"  @click=${change} data-panel="right"> 
                            <img src="static/images/settings.png" width="60px"/>
                              <span class='en' style="color:white; margin-left: 10px;">Change Number</span>
                              <span class='cn' style="color:white; margin-left: 10px;">更改号码</span>
                              <span class='tl' style="color:white; margin-left: 10px;">Telemovel Troka</span>
                          </a>
                        </td>
                      </tr>
                    </table>
                  </p>
                </div>
              </div>  
              <div class="block" style="text-align: center;">
                <img src="static/images/gov.png" width="70%"/>
              </div>
              

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Views/Tabs container -->
    <div class="views tabs safe-areas">
      <!-- Tabbar for switching views-tabs -->
      

      <!-- Your main view/tab, should have "view-main" class. It also has "tab-active" class -->
      <div id="view-home" class="view view-main view-init tab tab-active" data-name="home" data-url="/web_home/">
        <!-- Home page will be loaded here dynamically from / route -->
      </div>

      <!-- Catalog View -->
      <div id="view-pay" class="view view-init tab" data-name="pay" data-url="/cashier_pay/">
        <!-- Catalog page will be loaded here dynamically from /catalog/ route -->
      </div>
      <!-- Settings View -->
      <div id="view-result" class="view view-init tab" data-name="result" data-url="/kiosk_result/">
        <!-- Settings page will be loaded here dynamically from /settings/ route -->
      </div>

      <!-- Settings View -->
      <div id="view-settings" class="view view-init tab" data-name="settings" data-url="/settings/">
        <!-- Settings page will be loaded here dynamically from /settings/ route -->
      </div>
    </div>


    <!-- Popup -->
    <div class="popup" id="web-popup">
      <div class="view">
        <div class="page">
          <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner">
              <div class="title">
                <span class='en'>Mobile Number</span>
                <span class='cn'>手机号码</span>
                <span class='tl'>Telemovel Numeru</span>
              </div>
              <div class="right">
                <div class="segmented" style="position:relative;left: -20px;">
                  <button class="button button-fill" style="background-color: #4D0C19;" @click=${changeLangEng}>ENG</button>
                  <button class="button button-fill" style="background-color: #4D0C19;width: 5px; color:tomato">|</button>
                  <button class="button button-fill" style="background-color: #4D0C19;" @click=${changeLangTetun}>TET    </button>
                </div>
                <a href="#" class="link popup-close" @click=${skip}>
                  <span class='en'>Skip</span>
                  <span class='cn'>跳过</span>
                  <span class='tl'>Hakat Liu</span>
                </a>
              </div>
            </div>
          </div>
          <div class="page-content">
            <br/>
            <br/>
            <div class="block">
              <p>
                <span class='en'>Please enter your mobile number for verification.</span>
                <span class='cn'>请输入您的手机号码进行验证。</span>
                <span class='tl'>Favor tama telemovel numeru ba verifikasaun.</span>
              </p>
            </div>
            <div class="block">
              <p><b>
                <span class='en'>Mobile Number</span>
                <span class='cn'>手机号码</span>
                <span class='tl'>Telemovel Numeru</span>
              </b></p>
            </div>

              <div class="list no-hairlines no-hairlines-between" style="margin-left:0px;background-color: transparent;margin-top: -30px;">
                <ul style="background-color:transparent">
                  <li class="item-content item-input item-input-outline">
                    <div class="item-inner" style="width: 40%;">
                      <div class="item-title item-floating-label"></div>
                      <div class="item-input-wrap input-dropdown-wrap">
                        <select id="remarksCountryWeb">
                          <option value="+670" selected="selected">+670</option>
                        </select>
                      </div>
                    </div>
                    <div class="item-inner">
                      <div class="item-title item-floating-label">
                        <span class='en'>Phone</span>
                        <span class='cn'>电话</span>
                        <span class='tl'>Telemovel</span>
                      </div>
                      <div class="item-input-wrap">
                        <input type="tel" id="remarksWeb" pattern="\\d*" placeholder="" value=""/>
                        <span class="input-clear-button"></span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div> 
        
        
 

              <p class="segmented block">
                <button class="button button-outline" @click=${skip}>
                  <span class='en'>SKIP</span>
                  <span class='cn'>跳过</span>
                  <span class='tl'>HAKAT LIU</span>
                </button>
                <button class="button button-outline button-active"  @click=${save}>
                  <span class='en'>SUBMIT</span>
                  <span class='cn'>提交</span>
                  <span class='tl'>HATAMA</span>
                </button>
              </p>         
          </div>
        </div>
      </div>
    </div>


  </div>
`
    }
    ;
}

framework7Component.id = '442484ffa0';
export default framework7Component;